var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 104,
    viewBox: "0 0 400 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8907 84.1745L21.5406 87.9463C11.6993 92.9964 0 85.8502 0 74.7888C0 66.6212 6.62115 60 14.7888 60H384.225C392.937 60 400 67.0627 400 75.7749C400 83.4252 394.511 89.9728 386.978 91.3077L371.29 94.0878C364.267 95.3324 357.031 94.3876 350.563 91.3812L346.821 89.6422C333.092 83.2611 316.946 83.8628 303.634 91.0735C294.235 96.1644 283.279 98.0967 272.721 96.4297L264.902 95.195C255.721 93.7454 246.346 94.086 237.294 96.198L223.286 99.4666C212.025 102.094 200.234 101.257 189.457 97.0665L183.028 94.5664C174.613 91.2938 165.313 91.0901 156.763 93.9912C147.296 97.2032 136.95 96.598 127.922 92.3043L118.355 87.7543C107.253 82.474 94.4953 81.8734 82.946 86.0873L76.6619 88.3801C68.5936 91.3239 59.6603 90.7467 52.038 86.789L47.0867 84.2181C41.3862 81.2582 34.6054 81.242 28.8907 84.1745Z",
    fill: "#FFCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.9543 8.95431 0 20 0H380C391.046 0 400 8.95431 400 20V77H0V20Z",
    fill: "#FFCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedBg);
export default __webpack_public_path__ + "static/media/redBg.1d73740d78096951a4b20804067aa926.svg";
export { ForwardRef as ReactComponent };